export enum TicketStatus {
  PENDING,
  REQUESTED,
  INVOICED,
  DUPLICATED,
  UNREADABLE,
  EXPIRED,
  INVALID,
}
